import { render } from "./Logo.vue?vue&type=template&id=0ca06b7f&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=0ca06b7f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Benjamin\\Desktop\\Hudplejeklinikken Esbjerg\\code\\hpke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca06b7f"]])

export default __exports__